// Curated quality scores for great roads (1-3; 3 = national-caliber, highest).
// Source: Morgan's "Great Roads Master List" (817 scored roads) + earlier sets.
// Used to break ties when several curated roads are candidates (higher wins).
export const GREAT_ROAD_SCORES: Record<string, number> = {
  "route-des-etangs-de-hollande-rambouillet-forest": 3,
  "route-de-limperatrice-saint-cloud": 3,
  "route-de-la-reine-blanche-fontainebleau": 3,
  "route-ronde-fontainebleau": 2,
  "route-de-la-faisanderie-fontainebleau": 2,
  "d91-chevreuse-valley": 3,
  "route-des-vaux-de-cernay-chevreuse-valley": 3,
  "d24-chevreuse-valley": 2,
  "d906-chevreuse-valley": 2,
  "d36-chevreuse-valley": 3,
  "avenue-de-madrid-neuilly-sur-seine": 2,
  "boulevard-maurice-barres-neuilly-sur-seine": 2,
  "avenue-charles-de-gaulle-neuilly-sur-seine": 1,
  "route-de-suresnes-bois-de-boulogne": 2,
  "allee-de-longchamp-bois-de-boulogne": 2,
  "avenue-foch-paris-16e": 2,
  "avenue-henri-martin-paris-16e": 2,
  "rue-de-passy-paris-16e": 1,
  "avenue-raphael-paris-16e": 2,
  "rue-de-luniversite-paris-7e": 2,
  "rue-de-grenelle-paris-7e": 2,
  "rue-de-varenne-paris-7e": 2,
  "rue-jacob-saint-germain-des-pres": 2,
  "rue-bonaparte-saint-germain-des-pres": 2,
  "rue-des-barres-le-marais": 2,
  "rue-vieille-du-temple-le-marais": 2,
  "rue-des-francs-bourgeois-le-marais": 2,
  "rue-de-labreuvoir-montmartre": 3,
  "avenue-junot-montmartre": 2,
  "rue-lepic-montmartre": 2,
  "moyenne-corniche-nice-to-monaco": 3,
  "grande-corniche-nice-to-la-turbie": 3,
  "basse-corniche-nice-to-monaco": 3,
  "route-du-mont-boron-nice": 3,
  "boulevard-du-mont-boron-nice": 2,
  "boulevard-carnot-nice": 2,
  "promenade-des-anglais-nice": 2,
  "route-forestiere-du-mont-boron-nice": 2,
  "route-de-saint-jean-cap-ferrat-cap-ferrat": 3,
  "boulevard-du-general-de-gaulle-saint-jean-cap-ferrat": 3,
  "avenue-denis-semeria-saint-jean-cap-ferrat": 2,
  "boulevard-maurice-rouvier-beaulieu-sur-mer-cap-ferrat": 3,
  "avenue-edith-cavell-beaulieu-sur-mer": 2,
  "boulevard-edouard-vii-cap-dantibes": 3,
  "boulevard-john-f-kennedy-antibes-cap-dantibes": 3,
  "chemin-des-douaniers-access-roads-cap-dantibes": 2,
  "boulevard-de-la-garoupe-cap-dantibes": 2,
  "croisette-boulevard-cannes": 2,
  "avenue-du-roi-albert-1er-cannes": 2,
  "boulevard-de-la-corniche-dor-esterel-coast": 3,
  "route-de-lesterel-esterel-theoule": 3,
  "route-des-cretes-eze-la-turbie": 3,
  "route-de-la-turbie-monaco-hinterland": 2,
  "moyenne-corniche-through-eze-eze": 3,
  "d2564-nice-hinterland": 2,
  "route-de-saint-paul-saint-paul-de-vence": 2,
  "route-de-vence-vence-saint-paul": 2,
  "route-de-gourdon-gourdon": 3,
  "route-de-larriere-pays-grassois-grasse-hinterland": 2,
  "route-de-coaraze-coaraze": 2,
  "d177-around-gordes-luberon": 3,
  "d2-through-gordes-and-roussillon-luberon": 3,
  "d4-through-bonnieux-luberon": 3,
  "d900-luberon": 2,
  "d943-luberon-lourmarin": 3,
  "route-de-menerbes-luberon": 2,
  "route-de-lacoste-luberon": 2,
  "route-de-goult-luberon": 2,
  "route-de-saignon-apt-luberon": 2,
  "d974-mont-ventoux-vaucluse": 3,
  "gorges-de-la-nesque-road-vaucluse": 3,
  "route-des-cretes-cassis-la-ciotat": 3,
  "corniche-kennedy-marseille": 2,
  "route-des-goudes-marseille": 2,
  "route-de-cezanne-aix-en-provence": 3,
  "d17-toward-sainte-victoire-aix-en-provence": 3,
  "route-de-saint-remy-to-les-baux-alpilles": 3,
  "d27-through-the-alpilles-alpilles": 3,
  "d5-near-maussane-les-alpilles-alpilles": 2,
  "route-de-camargue-camargue": 2,
  "route-de-la-mer-saintes-maries-de-la-mer": 2,
  "route-des-lavandes-valensole-plateau": 3,
  "d8-through-valensole-valensole": 2,
  "route-de-moustiers-sainte-marie-verdon": 3,
  "route-des-cretes-du-verdon-gorges-du-verdon": 3,
  "d952-along-the-verdon-gorges-du-verdon": 3,
  "route-de-cotignac-var": 2,
  "route-de-seillans-fayence-country": 2,
  "route-de-tourtour-haut-var": 2,
  "route-de-bormes-les-mimosas-var-coast": 2,
  "d2-medoc-wine-route-bordeaux-medoc": 3,
  "route-des-chateaux-du-medoc-bordeaux-medoc": 3,
  "d209-through-saint-emilion-saint-emilion": 3,
  "d243-through-pomerol-pomerol": 2,
  "route-de-sauternes-sauternes": 2,
  "route-des-vins-de-bourgogne-burgundy": 3,
  "route-des-grands-crus-cote-dor": 3,
  "d974-through-meursault-and-puligny-burgundy": 3,
  "d18-through-loire-valley-chateaux-loire-valley": 3,
  "levee-de-la-loire-loire-valley": 3,
  "d751-along-the-loire-loire-valley": 2,
  "route-de-chambord-loir-et-cher": 3,
  "route-damboise-to-chenonceaux-loire-valley": 2,
  "route-des-vins-dalsace-alsace": 3,
  "d1b-through-riquewihr-and-hunawihr-alsace": 3,
  "d11-through-kaysersberg-alsace": 3,
  "route-des-cretes-des-vosges-vosges-alsace": 3,
  "route-des-grandes-alpes-french-alps": 3,
  "col-de-liseran-road-french-alps": 3,
  "col-du-galibier-road-french-alps": 3,
  "col-de-la-bonette-road-mercantour-alps": 3,
  "route-napoleon-alps-provence": 3,
  "route-des-grandes-alpes-through-beaufortain-savoie": 3,
  "route-du-mont-saint-michel-normandy": 3,
  "d514-cote-fleurie-normandy-coast": 2,
  "route-des-chaumieres-normandy": 3,
  "route-du-cidre-pays-dauge": 3,
  "d940-opal-coast-northern-france": 3,
  "route-du-cap-frehel-brittany": 3,
  "route-de-la-cote-de-granit-rose-brittany": 3,
  "corniche-de-larmorique-brittany": 2,
  "route-de-la-pointe-du-raz-brittany": 3,
  "d81-calanques-de-piana-corsica": 3,
  "d80-cap-corse-corsica": 3,
  "d268-bavella-corsica": 3,
  "route-de-bonifacio-southern-corsica": 3,
  "route-de-rocamadour-lot": 3,
  "route-de-saint-cirq-lapopie-lot-valley": 3,
  "d703-dordogne-valley-dordogne": 3,
  "route-de-sarlat-to-beynac-dordogne": 3,
  "route-du-pays-basque-coast-basque-coast": 3,
  "route-de-la-corniche-basque-hendaye-ciboure": 3,
  "avenue-de-breteuil-paris-7e": 2,
  "avenue-de-saxe-paris-7e": 2,
  "rue-saint-dominique-paris-7e": 2,
  "rue-cler-paris-7e": 1,
  "avenue-victor-hugo-paris-16e": 2,
  "rue-de-la-pompe-paris-16e": 1,
  "boulevard-suchet-paris-16e": 2,
  "boulevard-lannes-paris-16e": 2,
  "avenue-de-lamballe-paris-16e": 2,
  "rue-berton-paris-16e": 2,
  "rue-saint-louis-en-lile-ile-saint-louis": 3,
  "quai-danjou-ile-saint-louis": 3,
  "quai-de-bourbon-ile-saint-louis": 3,
  "rue-des-archives-le-marais": 2,
  "rue-saint-antoine-le-marais": 1,
  "rue-beautreillis-le-marais": 2,
  "rue-des-tournelles-le-marais": 2,
  "avenue-de-la-bourdonnais-paris-7e": 2,
  "avenue-rapp-paris-7e": 2,
  "rue-de-luniversite-near-eiffel-tower-paris-7e": 2,
  "avenue-george-v-paris-8e": 2,
  "avenue-montaigne-paris-8e": 2,
  "rue-du-faubourg-saint-honore-paris-8e": 2,
  "avenue-gabriel-paris-8e": 2,
  "cours-albert-1er-paris-8e": 2,
  "route-de-la-muette-a-neuilly-bois-de-boulogne": 2,
  "route-de-saint-cloud-a-suresnes-bois-de-boulogne": 2,
  "avenue-de-saint-cloud-versailles": 2,
  "avenue-de-paris-versailles": 2,
  "rue-de-la-paroisse-versailles": 1,
  "route-des-moulins-chevreuse-valley": 2,
  "rue-de-la-division-leclerc-chevreuse": 1,
  "route-de-dampierre-chevreuse-valley": 2,
  "d13-through-montfort-lamaury-yvelines": 2,
  "route-de-gambaiseuil-rambouillet-forest": 2,
  "avenue-princesse-grace-monaco": 2,
  "boulevard-ditalie-monaco": 2,
  "avenue-hector-otto-monaco": 2,
  "route-de-la-moyenne-corniche-villefranche-sur-mer": 3,
  "avenue-bella-vista-villefranche-sur-mer": 2,
  "boulevard-de-la-corne-dor-villefranche-sur-mer": 2,
  "avenue-des-hellenes-beaulieu-sur-mer": 2,
  "boulevard-marinoni-beaulieu-sur-mer": 2,
  "avenue-jean-mermoz-saint-jean-cap-ferrat": 2,
  "chemin-de-saint-hospice-cap-ferrat": 3,
  "route-de-la-madone-menton-roquebrune": 2,
  "promenade-le-corbusier-access-roads-roquebrune-cap-martin": 2,
  "avenue-de-la-madone-menton": 2,
  "boulevard-de-garavan-menton": 2,
  "route-de-castellar-menton-hinterland": 2,
  "route-de-peille-peille": 2,
  "route-de-luceram-paillon-valley": 2,
  "route-de-sospel-bevera-valley": 2,
  "route-de-tende-mercantour-gateway": 2,
  "route-de-biot-biot": 2,
  "route-de-valbonne-valbonne": 2,
  "route-de-mougins-mougins": 2,
  "avenue-saint-basile-mougins": 2,
  "route-de-tanneron-tanneron": 2,
  "route-du-mimosa-tanneron-mandelieu": 2,
  "corniche-dor-through-theoule-theoule-sur-mer": 3,
  "route-de-saint-tropez-golfe-de-saint-tropez": 2,
  "route-de-ramatuelle-ramatuelle": 3,
  "route-des-plages-ramatuelle": 2,
  "route-de-lescalet-ramatuelle": 2,
  "route-de-venasque-vaucluse": 2,
  "route-du-barroux-vaucluse": 2,
  "route-des-dentelles-gigondas-beaumes-de-venise": 3,
  "d90-through-gigondas-southern-rhone": 2,
  "route-de-seguret-southern-rhone": 2,
  "route-de-vaison-la-romaine-vaucluse": 2,
  "route-de-chateauneuf-du-pape-southern-rhone": 3,
  "d17-through-sainte-victoire-aix-country": 3,
  "route-du-tholonet-aix-country": 2,
  "route-de-puyloubier-sainte-victoire": 2,
  "route-de-jouques-aix-hinterland": 2,
  "route-de-cucuron-luberon": 2,
  "route-dansouis-luberon": 2,
  "route-de-vaugines-luberon": 2,
  "route-de-cadenet-luberon": 1,
  "route-de-simiane-la-rotonde-haute-provence": 3,
  "route-de-banon-haute-provence": 2,
  "route-de-forcalquier-haute-provence": 2,
  "route-de-lurs-haute-provence": 2,
  "route-de-mane-haute-provence": 2,
  "route-daups-verdon-var": 2,
  "route-de-baudinard-verdon": 2,
  "route-de-cotignac-to-sillans-var": 2,
  "route-de-correns-var": 2,
  "route-de-porquerolles-ferry-approach-hyeres": 2,
  "alpine-loop-scenic-byway-american-fork-canyon": 3,
  "apache-trail-apache-junction-az": 3,
  "apaquogue-road-east-hampton": 3,
  "argilla-road-ipswich": 3,
  "armstrong-parkway-highland-park": 3,
  "ashley-river-road-charleston": 3,
  "bateman-road-barrington": 3,
  "bay-view-drive-camden": 3,
  "beartooth-highway-red-lodge": 3,
  "bellevue-avenue-newport": 3,
  "birmingham-road-milton": 3,
  "blackburn-road-sewickley-heights": 3,
  "bluff-drive-savannah": 3,
  "bohicket-road-johns-island": 3,
  "botany-bay-road-edisto-island": 3,
  "brandywine-creek-road-chadds-ford": 3,
  "bridger-canyon-road-bozeman": 3,
  "burr-trail-road-boulder": 3,
  "bush-highway-mesa": 3,
  "cape-perpetua-scenic-drive-oregon-coast": 3,
  "cape-rosier-road-brooksville": 3,
  "cascade-lakes-scenic-byway-bend": 3,
  "caterpillar-hill-road-sedgwick": 3,
  "cave-creek-road-cave-creek": 3,
  "center-road-old-mission-peninsula": 3,
  "center-road-traverse-city": 3,
  "chestnut-ridge-road-bedford": 3,
  "chickasaw-gardens-drive-memphis": 3,
  "cloudland-road-woodstock": 3,
  "coast-highway-laguna-beach": 3,
  "corn-neck-road-block-island": 3,
  "creek-road-chadds-ford": 3,
  "cuba-road-barrington-hills": 3,
  "daniel-bray-highway-stockton": 3,
  "daniels-lane-sagaponack": 3,
  "darling-hill-road-lyndon": 3,
  "deerpath-road-lake-forest": 3,
  "denali-park-road-denali": 3,
  "devils-backbone-wimberley": 3,
  "diamond-causeway-skidaway-island": 3,
  "east-mountain-road-cold-spring": 3,
  "east-shore-road-flathead-lake": 3,
  "east-valley-road-montecito": 3,
  "east-warren-road-warren": 3,
  "esplanade-avenue-new-orleans": 3,
  "evans-notch-road-western-maine": 3,
  "farm-street-dover": 3,
  "flying-point-road-water-mill": 3,
  "fm-455-pilot-point": 3,
  "forbidden-drive-philadelphia": 3,
  "freemanville-road-milton": 3,
  "further-lane-east-hampton": 3,
  "gallatin-road-big-sky-mt": 3,
  "georgetown-pike-mclean": 3,
  "georgetown-pike-mclean-great-falls": 3,
  "gin-lane-southampton": 3,
  "glenn-highway-matanuska": 3,
  "going-to-the-sun-road-glacier": 3,
  "grandview-avenue-mount-washington": 3,
  "great-river-road-plantation-country": 3,
  "great-road-princeton": 3,
  "guardsman-pass-road-park-city": 3,
  "hamilton-pool-road-dripping-springs": 3,
  "hatcher-pass-road-palmer": 3,
  "hickory-hill-road-argyle": 3,
  "highway-128-moab": 3,
  "historic-columbia-river-highway-corbett": 3,
  "irish-hill-road-washington-county": 3,
  "jefferson-notch-road-jefferson": 3,
  "jerusalem-road-cohasset": 3,
  "kancamagus-highway-white-mountains": 3,
  "kiawah-island-parkway-kiawah-island": 3,
  "kolob-terrace-road-zion-region": 3,
  "la-sal-mountain-loop-road-moab": 3,
  "lake-road-skaneateles": 3,
  "lakeshore-drive-harbor-springs": 3,
  "lakeside-drive-highland-park": 3,
  "lamington-road-bedminster": 3,
  "lawther-drive-white-rock-lake": 3,
  "lighthouse-road-aquinnah": 3,
  "lime-creek-road-volente": 3,
  "lincoln-gap-road-mad-river-valley": 3,
  "little-sewickley-creek-road-sewickley": 3,
  "lombardy-road-san-marino": 3,
  "lullwater-road-druid-hills": 3,
  "m-119-harbor-springs": 3,
  "m-119-tunnel-of-trees-harbor-springs": 3,
  "m-22-leelanau-peninsula": 3,
  "mckenzie-river-highway-mckenzie-river": 3,
  "meadow-lane-southampton": 3,
  "memorial-drive-houston": 3,
  "middle-road-marthas-vineyard": 3,
  "ministerial-road-south-kingstown": 3,
  "mirror-lake-highway-uinta-mountains": 3,
  "monument-street-concord": 3,
  "moose-river-road-old-forge": 3,
  "mount-paran-road-sandy-springs": 3,
  "mountville-road-middleburg-dc-va-md": 3,
  "n-county-road-palm-beach": 3,
  "narrow-river-road-north-fork": 3,
  "navesink-river-road-rumson": 3,
  "north-road-carlisle": 3,
  "north-road-marthas-vineyard": 3,
  "oak-alley-road-vacherie": 3,
  "ocean-boulevard-rye": 3,
  "ocean-drive-newport": 3,
  "old-albany-post-road-garrison": 3,
  "old-cutler-road-coral-gables": 3,
  "old-mckenzie-highway-central-oregon": 3,
  "oregon-road-north-fork": 3,
  "otter-crest-loop-depoe-bay": 3,
  "pacific-coast-highway-malibu-ca": 3,
  "palos-verdes-drive-west": 3,
  "park-loop-road-bar-harbor": 3,
  "peapack-road-far-hills": 3,
  "peninsula-drive-old-mission-peninsula": 3,
  "pierce-stocking-scenic-drive-sleeping-bear-dunes": 3,
  "pocomo-road-pocomo": 3,
  "polpis-road-nantucket": 3,
  "poplar-pike-germantown": 3,
  "pretty-brook-road-princeton": 3,
  "quidnet-road-nantucket": 3,
  "ranch-road-2222-austin": 3,
  "rancho-california-road-temecula": 3,
  "research-forest-drive-the-woodlands": 3,
  "richardson-highway-valdez-region": 3,
  "river-oaks-boulevard-houston": 3,
  "river-road-chadds-ford": 3,
  "river-road-johns-island": 3,
  "river-road-new-hope": 3,
  "river-road-princeton": 3,
  "river-road-tivoli": 3,
  "riverside-drive-memphis": 3,
  "route-100-central-vermont": 3,
  "route-16a-jackson": 3,
  "route-27-rangeley": 3,
  "route-6a-cape-cod-ma": 3,
  "route-73-keene-valley": 3,
  "royal-palm-way-palm-beach": 3,
  "sakonnet-point-road-little-compton": 3,
  "sandwich-notch-road-sandwich": 3,
  "santiago-canyon-road-orange-county": 3,
  "saxonburg-boulevard-fox-chapel": 3,
  "scenic-byway-12-southern-utah": 3,
  "scenic-drive-austin": 3,
  "seven-lakes-drive-harriman": 3,
  "seward-highway-anchorage": 3,
  "sheridan-road-lake-forest": 3,
  "sherwood-road-lake-forest": 3,
  "skalkaho-highway-bitterroot": 3,
  "smugglers-notch-road-stowe-vt": 3,
  "snickersville-turnpike-loudoun-county": 3,
  "sound-avenue-north-fork": 3,
  "south-boulevard-houston": 3,
  "south-ocean-boulevard-palm-beach": 3,
  "south-parkway-memphis": 3,
  "south-road-marthas-vineyard": 3,
  "spear-street-charlotte": 3,
  "squam-lake-road-holderness": 3,
  "st-charles-avenue-new-orleans": 3,
  "stowe-hollow-road-stowe": 3,
  "sugartown-road-malvern": 3,
  "summit-road-south-mountain": 3,
  "thompson-pass-road-valdez": 3,
  "torch-lake-drive-torch-lake": 3,
  "torrey-pines-park-road-la-jolla": 3,
  "tuxedo-road-atlanta": 3,
  "us-89-paradise-valley": 3,
  "us-89-paradise-valley-mt": 3,
  "village-lane-orient": 3,
  "vineyard-drive-dundee": 3,
  "west-paces-ferry-road-atlanta": 3,
  "west-side-road-north-conway": 3,
  "weston-road-lincoln": 3,
  "whiteface-memorial-highway-wilmington": 3,
  "wormsloe-historic-site-road-savannah": 3,
  "a1a-gulf-stream": 2,
  "adirondack-loj-road-lake-placid": 2,
  "alyeska-highway-girdwood": 2,
  "antelope-island-road-great-salt-lake": 2,
  "aquetong-road-new-hope": 2,
  "arden-valley-road-harriman": 2,
  "arnold-mill-road-milton": 2,
  "arroyo-boulevard-pasadena": 2,
  "atlantic-avenue-cohasset": 2,
  "atlantic-avenue-delray-beach": 2,
  "atoka-road-marshall-middleburg": 2,
  "audubon-boulevard-new-orleans": 2,
  "aufderheide-scenic-byway-western-cascades": 2,
  "babcock-boulevard-north-park": 2,
  "banyan-road-boca-raton": 2,
  "barataria-boulevard-jefferson-parish": 2,
  "barnard-road-barnard": 2,
  "bartlett-dam-road-scottsdale": 2,
  "basin-road-phippsburg": 2,
  "baxter-road-nantucket": 2,
  "bay-avenue-east-marion": 2,
  "bayou-road-new-orleans": 2,
  "bayou-st-john-drive-new-orleans": 2,
  "bayshore-drive-coconut-grove": 2,
  "beach-avenue-kennebunkport": 2,
  "beach-drive-washington-dc-dc-va-md": 2,
  "beach-mill-road-great-falls-dc-va-md": 2,
  "beach-road-vineyard-haven-oak-bluffs": 2,
  "beacon-hill-road-newport": 2,
  "bear-canyon-road-bozeman": 2,
  "bear-notch-road-bartlett": 2,
  "bears-bluff-road-wadmalaw-island": 2,
  "beauchamp-point-road-rockport": 2,
  "beaver-road-sewickley": 2,
  "beavertail-road-jamestown": 2,
  "bee-cave-road-austin": 2,
  "beechwood-boulevard-squirrel-hill": 2,
  "belfast-keller-road-richmond-hill": 2,
  "bell-road-newberg": 2,
  "bells-bay-road-charlevoix": 2,
  "ben-sawyer-boulevard-mount-pleasant": 2,
  "bernardsville-mountain-road-bernardsville": 2,
  "betsy-kerrison-parkway-kiawah-island": 2,
  "beverly-drive-highland-park": 2,
  "big-cottonwood-canyon-road-salt-lake-area": 2,
  "bingham-avenue-rumson": 2,
  "blackland-road-atlanta": 2,
  "bluff-road-glencoe": 2,
  "bluff-road-old-mission-peninsula": 2,
  "bois-darc-lane-fulshear": 2,
  "bound-brook-island-road-wellfleet": 2,
  "boyne-city-road-charlevoix": 2,
  "braeburn-road-barrington-hills": 2,
  "bragg-hill-road-fayston": 2,
  "briar-forest-drive-houston": 2,
  "brickyard-road-potomac-dc-va-md": 2,
  "bridge-street-provincetown": 2,
  "brintons-bridge-road-chadds-ford": 2,
  "browns-canyon-road-park-city": 2,
  "bryan-woods-road-richmond-hill": 2,
  "buffalo-bayou-park-drive-houston": 2,
  "burkittsville-road-poolesville-dc-va-md": 2,
  "butler-avenue-tybee-island": 2,
  "byhalia-road-collierville": 2,
  "camas-road-west-glacier": 2,
  "camino-real-boca-raton": 2,
  "camp-street-new-orleans": 2,
  "cape-meares-loop-road-cape-meares": 2,
  "capitol-reef-scenic-drive-capitol-reef": 2,
  "card-sound-road-florida-city": 2,
  "carefree-highway-phoenix": 2,
  "carter-notch-road-jackson": 2,
  "carter-road-princeton": 2,
  "castle-valley-road-moab": 2,
  "cave-creek-canyon-road-carefree": 2,
  "cayuga-lake-scenic-byway-cayuga-lake": 2,
  "cecil-bay-road-mackinaw-area": 2,
  "center-creek-road-heber-valley": 2,
  "central-avenue-memphis": 2,
  "centre-street-sherborn": 2,
  "century-drive-bend": 2,
  "chain-bridge-road-mclean-dc-va-md": 2,
  "channel-drive-montecito": 2,
  "chapel-lane-orient": 2,
  "chapel-road-fox-chapel": 2,
  "chapel-road-wadmalaw-island": 2,
  "chef-menteur-highway-new-orleans-east": 2,
  "chena-hot-springs-road-fairbanks": 2,
  "cherokee-road-buckhead": 2,
  "cherry-bend-road-leelanau-county": 2,
  "cherry-mountain-road-bretton-woods": 2,
  "cherry-point-road-wadmalaw-island": 2,
  "cherry-road-memphis": 2,
  "cherry-valley-road-princeton": 2,
  "chief-joseph-scenic-byway-yellowstone": 2,
  "chisolm-road-johns-island": 2,
  "church-road-charlevoix": 2,
  "city-park-road-austin": 2,
  "clara-barton-parkway-potomac-dc-va-md": 2,
  "claybrook-road-dover": 2,
  "cliff-drive-laguna-beach": 2,
  "cliff-road-nantucket-town": 2,
  "coast-boulevard-la-jolla": 2,
  "cochran-shoals-road-marietta": 2,
  "coco-plum-boulevard-boca-raton": 2,
  "cocoanut-row-palm-beach": 2,
  "coliseum-street-new-orleans": 2,
  "colts-neck-road-colts-neck": 2,
  "columns-drive-marietta": 2,
  "commercial-street-provincetown": 2,
  "common-road-waitsfield": 2,
  "concord-road-concord": 2,
  "copper-canyon-road-copper-canyon": 2,
  "coral-way-coral-gables": 2,
  "corey-creek-lane-southold": 2,
  "cornell-road-portland-west-hills": 2,
  "country-club-road-petoskey": 2,
  "county-route-2-roxbury": 2,
  "county-route-41-andes": 2,
  "county-route-519-warren": 2,
  "county-route-6-ancram": 2,
  "county-route-61-cambridge": 2,
  "covered-bridge-road-sergeantsville": 2,
  "cow-creek-road-lago-vista": 2,
  "crandon-boulevard-key-biscayne": 2,
  "creek-road-dripping-springs": 2,
  "crest-hill-road-delaplane-dc-va-md": 2,
  "crooked-street-granville": 2,
  "cross-timbers-road-double-oak": 2,
  "crown-point-highway-columbia-gorge": 2,
  "crown-point-road-lower-barataria": 2,
  "cuernavaca-drive-austin": 2,
  "cutler-road-cutler": 2,
  "dallas-hill-road-rangeley": 2,
  "dalton-highway-arctic": 2,
  "darby-paoli-road-newtown-square": 2,
  "dark-hollow-road-pipersville": 2,
  "davies-plantation-road-lakeland": 2,
  "day-forest-road-glen-arbor": 2,
  "de-portola-road-temecula": 2,
  "decker-canyon-road-malibu": 2,
  "division-street-east-greenwich": 2,
  "dobbins-road-south-mountain": 2,
  "dogwood-road-germantown": 2,
  "dorset-west-road-dorset": 2,
  "dorseyville-road-fox-chapel": 2,
  "doubletree-ranch-road-paradise-valley": 2,
  "dove-road-southlake": 2,
  "dublin-road-peterborough": 2,
  "dune-road-westhampton-beach": 2,
  "dynamite-boulevard-scottsdale": 2,
  "eagle-highway-leelanau-county": 2,
  "east-bluff-drive-penn-yan": 2,
  "east-burke-road-east-burke": 2,
  "east-canyon-road-morgan-county": 2,
  "east-lake-road-skaneateles": 2,
  "east-memorial-loop-drive-houston": 2,
  "east-parkway-south-memphis": 2,
  "east-river-road-paradise-valley": 2,
  "east-river-street-savannah": 2,
  "east-shore-road-jamestown": 2,
  "eastside-highway-bitterroot": 2,
  "ecola-park-road-cannon-beach": 2,
  "edgerton-highway-copper-river": 2,
  "edgewood-road-riverwoods": 2,
  "eel-point-road-madaket": 2,
  "egypt-lane-east-hampton": 2,
  "eklutna-lake-road-chugiak": 2,
  "el-vedado-road-palm-beach": 2,
  "elder-hill-road-driftwood": 2,
  "encinal-canyon-road-malibu": 2,
  "essex-coastal-scenic-byway-north-shore": 2,
  "etris-road-milton": 2,
  "everett-road-colts-neck": 2,
  "falls-bridge-road-blue-hill": 2,
  "falls-road-potomac-dc-va-md": 2,
  "farm-to-market-road-whitefish": 2,
  "ferguson-avenue-savannah": 2,
  "ferry-road-bristol": 2,
  "ferry-road-charlevoix": 2,
  "first-street-new-orleans": 2,
  "fisherville-road-fisherville": 2,
  "fishhook-road-palmer": 2,
  "fishtrap-road-denton": 2,
  "fitzhugh-road-dripping-springs": 2,
  "fleecydale-road-new-hope": 2,
  "fleming-springs-road-cave-creek": 2,
  "fletcher-hill-road-woodstock": 2,
  "flower-mound-road-flower-mound": 2,
  "fm-1093-fulshear": 2,
  "fm-359-fulshear": 2,
  "foothill-road-kalispell": 2,
  "forest-hill-irene-road-germantown": 2,
  "forest-way-drive-lake-forest": 2,
  "fort-getty-road-jamestown": 2,
  "fort-mcallister-road-richmond-hill": 2,
  "foxcroft-road-middleburg-dc-va-md": 2,
  "foxhall-road-washington-dc-dc-va-md": 2,
  "freezeland-road-linden-dc-va-md": 2,
  "frenchtown-road-east-greenwich": 2,
  "frost-valley-road-claryville": 2,
  "garland-road-white-rock-lake": 2,
  "gaston-street-savannah": 2,
  "germantown-avenue-philadelphia": 2,
  "germantown-road-portland": 2,
  "glen-mitchell-road-sewickley-heights": 2,
  "glen-road-potomac-dc-va-md": 2,
  "good-harbor-trail-leelanau-peninsula": 2,
  "goodlett-street-memphis": 2,
  "goose-pond-road-canaan": 2,
  "goshen-road-newtown-square": 2,
  "gosling-road-the-woodlands": 2,
  "governor-wentworth-highway-wolfeboro": 2,
  "granada-boulevard-coral-gables": 2,
  "gravelly-range-road-sw-montana": 2,
  "great-island-road-wellfleet": 2,
  "green-bay-road-winnetka": 2,
  "greenbelt-drive-shelby-farms": 2,
  "greenbush-road-charlotte": 2,
  "grindstone-island-roads-thousand-islands": 2,
  "grubbs-mill-road-berwyn": 2,
  "guard-hill-road-bedford": 2,
  "gulfstream-road-gulf-stream": 2,
  "habersham-road-atlanta": 2,
  "haegers-bend-road-barrington-hills": 2,
  "happy-valley-road-phoenix": 2,
  "harbor-drive-key-biscayne": 2,
  "harbor-road-southold": 2,
  "hardscrabble-road-bernardsville": 2,
  "hardscrabble-road-north-salem": 2,
  "harris-neck-road-townsend": 2,
  "harrison-avenue-newport": 2,
  "harts-run-road-fox-chapel": 2,
  "heards-ferry-road-sandy-springs": 2,
  "hedges-lane-sagaponack": 2,
  "hells-backbone-road-boulder": 2,
  "highland-drive-highland-park": 2,
  "highway-101-cannon-beach": 2,
  "highway-287-ennis": 2,
  "highway-9-zion-region": 2,
  "holland-road-far-hills": 2,
  "hook-road-bedford": 2,
  "hope-highway-hope": 2,
  "hope-street-bristol": 2,
  "hopewell-road-milton": 2,
  "horton-bay-road-charlevoix-county": 2,
  "hortons-lane-southold": 2,
  "hot-springs-road-montecito": 2,
  "houston-levee-road-collierville": 2,
  "hudson-bend-road-lake-travis": 2,
  "hulbert-avenue-brant-point": 2,
  "humphreys-boulevard-memphis": 2,
  "hurricane-mountain-road-north-conway": 2,
  "illinois-road-wilmette": 2,
  "indian-brook-road-garrison": 2,
  "indian-neck-lane-peconic": 2,
  "invergordon-road-paradise-valley": 2,
  "inwood-drive-river-oaks": 2,
  "inwood-road-dallas": 2,
  "irish-bayou-road-new-orleans-east": 2,
  "isle-of-hope-drive": 2,
  "jackson-creek-road-bozeman": 2,
  "jean-lafitte-boulevard-jean-lafitte": 2,
  "jeffreys-neck-road-ipswich": 2,
  "jenne-road-reading": 2,
  "jeter-road-bartonville": 2,
  "jett-ferry-road-sandy-springs": 2,
  "jobs-lane-southampton": 2,
  "johnson-road-germantown": 2,
  "johnson-road-southlake": 2,
  "jones-avenue-tybee-island": 2,
  "jungle-road-palm-beach": 2,
  "kalifornsky-beach-road-kenai": 2,
  "katama-road-edgartown": 2,
  "kelley-stand-road-manchester": 2,
  "kilkenny-road-richmond-hill": 2,
  "kings-highway-kennebunkport": 2,
  "kirby-drive-houston": 2,
  "kuykendahl-road-tomball": 2,
  "la-39-st-bernard-parish-la": 2,
  "lafayette-road-gladwyne": 2,
  "laguna-canyon-road-laguna-beach": 2,
  "laird-road-colts-neck": 2,
  "lake-cook-road-deerfield": 2,
  "lake-creek-road-heber-valley": 2,
  "lake-dunmore-road-salisbury": 2,
  "lake-five-road-west-glacier": 2,
  "lake-leelanau-drive-lake-leelanau": 2,
  "lake-road-lake-forest": 2,
  "lake-shore-drive-petoskey": 2,
  "lakeshore-boulevard-new-orleans": 2,
  "lakeshore-drive-new-orleans": 2,
  "lakeshore-road-lake-george": 2,
  "lakeside-parkway-flower-mound": 2,
  "lamberts-cove-road-west-tisbury": 2,
  "landings-way-south-skidaway-island": 2,
  "larch-mountain-road-corbett": 2,
  "larger-cross-road-far-hills": 2,
  "laroche-avenue-isle-of-hope": 2,
  "lazy-lane-boulevard-houston": 2,
  "leeds-manor-road-delaplane-dc-va-md": 2,
  "leon-c-simon-drive-new-orleans": 2,
  "lighthouse-road-orient-point": 2,
  "little-harbor-road-portsmouth": 2,
  "live-oak-canyon-road-trabuco-canyon": 2,
  "lone-mountain-trail-big-sky": 2,
  "long-grove-road-long-grove": 2,
  "long-island-road-moultonborough": 2,
  "long-point-road-mount-pleasant": 2,
  "long-pond-road-garrison": 2,
  "loop-360-austin-tx": 2,
  "loop-road-big-cypress": 2,
  "low-beach-road-sconset": 2,
  "lower-birmingham-road-alpharetta": 2,
  "lower-shore-drive-harbor-springs": 2,
  "lumber-lane-bridgehampton": 2,
  "m-109-sleeping-bear-dunes": 2,
  "m-204-suttons-bay": 2,
  "macarthur-boulevard-potomac-dc-va-md": 2,
  "madaket-road-madaket": 2,
  "magazine-street-new-orleans": 2,
  "main-highway-coconut-grove": 2,
  "main-road-mattituck-cutchogue": 2,
  "main-street-barnstable-village": 2,
  "main-street-charlestown": 2,
  "malibu-canyon-road-malibu": 2,
  "many-glacier-road-babb": 2,
  "mapleton-canyon-road-mapleton": 2,
  "matunuck-beach-road-south-kingstown": 2,
  "maybank-highway-johns-island": 2,
  "mcardle-roadway-mount-washington": 2,
  "mccarthy-road-wrangell": 2,
  "mcdowell-mountain-road-scottsdale": 2,
  "mckinnon-road-katy-prairie": 2,
  "mcnamee-road-portland-west-hills": 2,
  "mcqueens-island-trail-road-savannah": 2,
  "mcwhorter-drive-savannah": 2,
  "meadow-hill-road-barrington-hills": 2,
  "meeting-house-lane-little-compton": 2,
  "megunticook-street-camden": 2,
  "memorial-park-drive-houston": 2,
  "mendham-road-bernardsville": 2,
  "mermaid-lane-philadelphia": 2,
  "mianus-river-road-bedford": 2,
  "mid-mountain-road-park-city-area": 2,
  "middle-street-sullivans-island": 2,
  "milestone-road-nantucket": 2,
  "mill-creek-road-gladwyne": 2,
  "mitkof-highway-petersburg": 2,
  "mockingbird-lane-highland-park": 2,
  "mockingbird-lane-paradise-valley": 2,
  "modena-island-drive-savannah": 2,
  "monterey-road-eads": 2,
  "moonstone-beach-road-south-kingstown": 2,
  "moores-lane-greenport": 2,
  "morgan-horse-farm-road-middlebury": 2,
  "moultonborough-neck-road-moultonborough": 2,
  "mount-bonnell-road-austin": 2,
  "mount-nebo-road-north-hills": 2,
  "mount-philo-road-charlotte": 2,
  "mountain-road-blue-hill": 2,
  "mountain-road-milton": 2,
  "mountain-road-stowe": 2,
  "mountain-road-tuftonboro": 2,
  "mulholland-highway-malibu": 2,
  "music-street-west-tisbury": 2,
  "nameless-road-leander": 2,
  "nebo-loop-scenic-byway-central-utah": 2,
  "new-suffolk-road-cutchogue": 2,
  "newark-street-newark": 2,
  "nicholson-road-sewickley": 2,
  "nome-council-road-nome": 2,
  "north-bayview-road-southold": 2,
  "north-boulevard-houston": 2,
  "north-branch-trail-drive-morton-grove": 2,
  "north-fork-road-columbia-falls": 2,
  "north-greenway-drive-coral-gables": 2,
  "north-main-road-jamestown": 2,
  "north-ocean-boulevard-palm-beach": 2,
  "north-parkway-memphis": 2,
  "north-river-road-lee": 2,
  "north-road-greenport": 2,
  "north-scottsdale-road-scottsdale": 2,
  "northside-drive-atlanta": 2,
  "northwestern-avenue-chestnut-hill": 2,
  "notchbrook-road-stowe": 2,
  "nubble-road-york": 2,
  "oakdale-road-druid-hills": 2,
  "ocean-avenue-kennebunkport": 2,
  "ocean-avenue-newport": 2,
  "ocean-boulevard-corona-del-mar": 2,
  "ocean-boulevard-delray-beach": 2,
  "ocean-boulevard-york": 2,
  "ocean-drive-cape-may": 2,
  "ocean-drive-mount-desert-island": 2,
  "ocean-road-bridgehampton": 2,
  "ocean-view-drive-wellfleet": 2,
  "old-georgetown-road-mcclellanville": 2,
  "old-glenn-highway-eagle-river": 2,
  "old-highway-40-wasatch-back": 2,
  "old-justin-road-argyle": 2,
  "old-mill-road-lake-zurich": 2,
  "old-mission-road-traverse-city": 2,
  "old-ocean-boulevard-ocean-ridge": 2,
  "old-orchard-lane-orient": 2,
  "old-river-road-savannah": 2,
  "old-san-antonio-road-driftwood": 2,
  "old-street-road-peterborough": 2,
  "old-town-road-block-island": 2,
  "old-village-street-mount-pleasant": 2,
  "old-yellowstone-trail-livingston": 2,
  "onwentsia-road-lake-forest": 2,
  "orlando-road-san-marino": 2,
  "ortega-highway-orange-county-ca": 2,
  "overlook-drive-schenley-park": 2,
  "oysterponds-lane-orient": 2,
  "pa-route-68-butler": 2,
  "pace-bend-road-spicewood": 2,
  "paces-ferry-road-vinings": 2,
  "palm-boulevard-isle-of-palms": 2,
  "palmer-avenue-new-orleans": 2,
  "palos-verdes-drive-south": 2,
  "pamet-road-truro": 2,
  "paper-mill-road-marietta": 2,
  "paris-road-st-bernard-parish": 2,
  "parkers-ferry-road-ace-basin": 2,
  "parks-highway-interior-alaska": 2,
  "parrett-mountain-road-newberg": 2,
  "parsonage-lane-sagaponack": 2,
  "pascal-avenue-rockport": 2,
  "paseo-del-mar-san-pedro": 2,
  "peacham-road-peacham": 2,
  "peachtree-battle-avenue-buckhead": 2,
  "pearce-mill-road-north-park": 2,
  "peconic-bay-boulevard-laurel": 2,
  "peconic-lane-peconic": 2,
  "pilot-knob-road-lake-george": 2,
  "pima-road-scottsdale": 2,
  "pine-canyon-road-midway": 2,
  "pine-landing-road-edisto-island": 2,
  "pine-street-dover": 2,
  "piney-point-road-piney-point": 2,
  "pinkham-b-road-jackson": 2,
  "pitt-street-mount-pleasant": 2,
  "platte-clove-road-catskills": 2,
  "pleasant-valley-road-woodstown": 2,
  "point-of-pines-road-edisto-island": 2,
  "poppasquash-road-bristol": 2,
  "portage-glacier-road-portage": 2,
  "potash-road-moab": 2,
  "pottersville-road-bedminster": 2,
  "powers-court-drive-chastain": 2,
  "powers-ferry-road-atlanta": 2,
  "preston-road-dallas": 2,
  "prospect-mountain-highway-lake-george": 2,
  "prospect-street-la-jolla": 2,
  "prosper-road-woodstock": 2,
  "province-line-road-princeton": 2,
  "prytania-street-new-orleans": 2,
  "purgatory-road-middletown": 2,
  "quaker-ridge-road-chappaqua": 2,
  "quinn-road-collierville": 2,
  "raleigh-lagrange-road-fayette": 2,
  "ranch-road-12-wimberley": 2,
  "ranch-road-620-lake-travis": 2,
  "randol-mill-avenue-southlake": 2,
  "redbud-trail-austin": 2,
  "resort-pike-road-petoskey": 2,
  "ribbon-ridge-road-newberg": 2,
  "ridge-road-wilmette": 2,
  "ridgewood-road-vinings": 2,
  "riding-meadow-road-fox-chapel": 2,
  "rifle-range-road-mount-pleasant": 2,
  "rio-verde-drive-rio-verde": 2,
  "rip-van-winkle-drive-hunters-creek": 2,
  "river-hills-road-austin": 2,
  "river-place-boulevard-austin": 2,
  "river-road-32-bucks": 2,
  "river-road-barrington-hills": 2,
  "river-road-hanover": 2,
  "river-road-midway": 2,
  "river-road-park-city": 2,
  "river-road-potomac-dc-va-md": 2,
  "river-road-rhinebeck": 2,
  "river-road-west-bank": 2,
  "river-road-wimberley": 2,
  "river-road-woodstock": 2,
  "riverside-drive-sandy-springs": 2,
  "riverview-avenue-riverview-park": 2,
  "robinson-road-harbor-springs": 2,
  "rock-creek-road-philipsburg": 2,
  "rockhill-road-aubrey": 2,
  "rocky-point-road-east-marion": 2,
  "rosemont-ringoes-road-hunterdon": 2,
  "route-10-lyme": 2,
  "route-102-somesville": 2,
  "route-113-gilead": 2,
  "route-113-holderness": 2,
  "route-115-sherborn": 2,
  "route-117-lincoln": 2,
  "route-123-hancock": 2,
  "route-125-middlebury-gap": 2,
  "route-137-hancock": 2,
  "route-16-rangeley": 2,
  "route-17-appalachian-gap": 2,
  "route-1a-rye": 2,
  "route-28-catskills-ny": 2,
  "route-29-saratoga-county": 2,
  "route-301-cold-spring": 2,
  "route-52-camden-hills": 2,
  "route-9-downeast-maine": 2,
  "ruggles-avenue-newport": 2,
  "rumson-road-rumson": 2,
  "s-county-road-palm-beach": 2,
  "saddlewood-lane-hunters-creek": 2,
  "sagg-main-street-sagaponack": 2,
  "san-ysidro-road-montecito": 2,
  "sandy-pond-road-lincoln": 2,
  "sargent-drive-mdi": 2,
  "schenley-drive-oakland": 2,
  "school-house-road-cave-creek": 2,
  "schooner-head-road-bar-harbor": 2,
  "seawall-road-southwest-harbor": 2,
  "seneca-lake-scenic-byway-seneca-lake": 2,
  "seneca-road-great-falls-dc-va-md": 2,
  "seven-devils-road-bandon": 2,
  "seven-springs-road-cave-creek": 2,
  "sewall-road-wolfeboro": 2,
  "sewee-road-awendaw": 2,
  "shady-grove-road-memphis": 2,
  "shady-oaks-drive-southlake": 2,
  "shelton-road-collierville": 2,
  "shelving-rock-road-lake-george": 2,
  "shore-road-chatham": 2,
  "shore-road-ogunquit": 2,
  "skidaway-road-savannah": 2,
  "skilak-lake-road-kenai": 2,
  "skippers-lane-east-marion": 2,
  "skokie-valley-road-lake-forest": 2,
  "skyline-boulevard-portland": 2,
  "skyline-drive-keuka-lake": 2,
  "sleeping-child-road-hamilton": 2,
  "snake-hill-road-middleburg-dc-va-md": 2,
  "snow-canyon-drive-st-george": 2,
  "sonoran-desert-drive-phoenix": 2,
  "sound-drive-mdi": 2,
  "sound-ferry-road-orient": 2,
  "sound-view-avenue-greenport": 2,
  "south-bayshore-drive-coconut-grove": 2,
  "south-ponce-de-leon-avenue-druid-hills": 2,
  "south-street-weston": 2,
  "spanish-river-boulevard-boca-raton": 2,
  "spring-creek-road-barrington-hills": 2,
  "spring-mill-road-villanova": 2,
  "spring-street-block-island": 2,
  "springbrook-road-newberg": 2,
  "springhill-road-bozeman": 2,
  "springvale-road-great-falls-dc-va-md": 2,
  "spur-cross-road-cave-creek": 2,
  "squaw-run-road-fox-chapel": 2,
  "st-john-road-pilot-point": 2,
  "stage-harbor-road-chatham": 2,
  "stampede-road-healy": 2,
  "stanton-avenue-highland-park": 2,
  "star-meadows-road-whitefish": 2,
  "state-road-west-tisbury": 2,
  "station-22-street-sullivans-island-sc": 2,
  "steed-creek-road-awendaw": 2,
  "steese-highway-fairbanks": 2,
  "sterling-highway-kenai-peninsula": 2,
  "strait-lane-dallas": 2,
  "strawberry-hill-road-concord": 2,
  "stump-road-buckingham": 2,
  "succotash-road-south-kingstown": 2,
  "sudbury-road-concord": 2,
  "sugarland-road-poolesville-dc-va-md": 2,
  "sullivans-island-causeway-mount-pleasant": 2,
  "sunset-boulevard-cannon-beach": 2,
  "sunset-drive-south-miami": 2,
  "swamp-road-little-compton": 2,
  "sycamore-canyon-road-montecito": 2,
  "sycamore-street-mount-washington": 2,
  "tatum-boulevard-phoenix": 2,
  "tea-lane-chilmark": 2,
  "temple-hills-drive-laguna-beach": 2,
  "thornwood-lane-lake-forest": 2,
  "thousand-islands-parkway-area-roads-clayton": 2,
  "three-capes-scenic-drive-tillamook-coast": 2,
  "three-mile-road-hanover": 2,
  "tinker-street-woodstock": 2,
  "titicus-road-north-salem": 2,
  "tom-darlington-drive-carefree": 2,
  "tom-miner-creek-road-paradise-valley": 2,
  "tumalo-reservoir-road-bend": 2,
  "turnagain-pass-road-kenai": 2,
  "tuxedo-road-extension-chastain": 2,
  "tybee-road-tybee-island": 2,
  "usery-pass-road-mesa": 2,
  "valley-forge-road-wayne": 2,
  "valley-road-long-valley": 2,
  "valley-road-villanova": 2,
  "via-de-la-valle-del-mar": 2,
  "vista-house-road-columbia-gorge": 2,
  "walden-street-concord": 2,
  "walker-road-great-falls-dc-va-md": 2,
  "walnut-grove-road-memphis": 2,
  "washington-avenue-ardsley-park": 2,
  "washington-boulevard-highland-park": 2,
  "waverly-road-gladwyne": 2,
  "wellesley-island-state-park-roads-thousand-islands": 2,
  "west-bay-shore-drive-traverse-city": 2,
  "west-lake-drive-cazenovia": 2,
  "west-lake-road-canandaigua": 2,
  "west-main-road-little-compton": 2,
  "west-road-manchester": 2,
  "west-shore-road-flathead-lake": 2,
  "westlake-drive-austin": 2,
  "whiskey-run-road-bandon": 2,
  "white-horse-road-malvern": 2,
  "white-rock-road-dallas": 2,
  "whitefish-lake-road-whitefish": 2,
  "whites-ferry-road-poolesville-dc-va-md": 2,
  "whitmarsh-island-drive-savannah": 2,
  "wickapogue-road-southampton": 2,
  "wilderness-state-park-road-mackinaw-area": 2,
  "willowick-road-houston": 2,
  "winner-foster-road-fulshear": 2,
  "wolf-creek-pass-road-wasatch-back": 2,
  "wolf-river-boulevard-germantown": 2,
  "woodlands-parkway-the-woodlands": 2,
  "woods-road-germantown-ny": 2,
  "worden-hill-road-dundee": 2,
  "yellow-springs-road-chester-springs": 2,
  "zealand-road-twin-mountain": 2,
  "zion-park-boulevard-springdale": 2,
};

/** Returns the curated score for a road id, or 0 if unscored. */
export const greatRoadScore = (id: string): number => GREAT_ROAD_SCORES[id] ?? 0;
